import enhance from './MembershipContainer';
import CustomerMemberships from './Membership';

export default enhance(CustomerMemberships);
